import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Empty } from 'antd'

class NoOrders extends Component {
    render() {
        const { loading } = this.props

        return (
            <tr className='NoOrders'>
                <td colSpan={16}>
                    <Empty description={loading ? 'Loading data...' : 'No items'} />
                </td>
            </tr>
        )
    }
}

NoOrders.propTypes = {
    loading: PropTypes.bool.isRequired,
}

export default NoOrders
